export default __webpack_public_path__ + "static/media/metamask-alternative.717b7c18.png";